import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { getFileLiveUrl, LOADER_LOGO, makeUrl, momentDate } from "../../utils";
import PsContext from "../../context";

const Events = () => {
  const context = useContext(PsContext);
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setDataList([]);
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=event&" + "&limit=4")
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <section>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}
      <div className="container my-4 text_theme">
        <Row>
          {dataList.length > 0 &&
            dataList.map((item) => (
              <Col md={3} sm={6} xs={12} className="mt-2">
                <Link to={`/event/${item.id}/${makeUrl(item.title)}`}>
                  <div
                    className="card hover_event mt-3"
                    style={{
                      borderBottom: `3px solid ${context.settingValue(
                        "web_site_header_bgcolor"
                      )}`,
                      borderTop: `3px solid ${context.settingValue(
                        "web_site_header_bgcolor"
                      )}`,
                    }}
                  >
                    <img
                      src={getFileLiveUrl(item.feature_image)}
                      width="100%"
                      style={{ height: "250px" }}
                      className="p-2"
                      alt="..."
                    />
                    <div className="card-body body_card">
                      <p className="fw-bold text-center">
                        {" "}
                        {item.title.length > 25
                          ? `${item.title.substring(0, 25)}...`
                          : item.title}
                      </p>
                      <p className="text-center">
                        {momentDate(item.active_from_date, "MMM,DD,YYYY")}
                      </p>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
        </Row>
        <Col md={12} className="text-end mt-4 ">
          <Link to="/events" className="btn btn-outline-primary btn-sm">
            View All <i className="fas fa-angle-double-right ms-1"></i>
          </Link>
        </Col>
      </div>
    </section>
  );
};

export default Events;
